<template>
  <div>
      <!-- custom header -->
      <div slot="modal-header" class="modal-header" >
        <h4 class="modal-title" style="">
          <strong>機器・組込情報の申請が完了しました。</strong>
        </h4>
      </div>
        <button type="button" style="width:120px;" :class="'btn btn-default ' " @click="closed('no')">戻る</button>
  </div>
</template>

<script>
import Vue from "vue";
import { bus } from "@/libs/bus";
import { utils } from "@/libs/utils";
var vm = this;

import  modal  from "./local-modal";
Vue.component("modal", modal);

import debug from "debug";
var debug_msg = debug("esma:bulk-import-confirmation-modal");

export default {
  data() {
    return {
      show_modal: false,
      callback:null,
      model_height:"350",
      team_options:["tA","E","D","C"],
      user_options:["uA","E","D","C"],
      local_user_list:[]
    };
  },
  computed: {
    localUserList:{
      get(){
        return this.local_user_list;
      },
      set(v){
        this.userOptions = v.map(o => {return o.user_shimei;});
        this.teamOptions = v.map(o => {return o.team;});
        this.local_user_list = v;
      }
    },
    userDepartment() {
      return Vue.localStorage.get("userDepartment") || "";
    },
    userTeam() {
      return Vue.localStorage.get("userTeam") || "";
    },
    userShimei() {
      return Vue.localStorage.get("userShimei") || "";
    },
    userOptions:{
      get(){
        return this.user_options;
      },
      set(v){
        this.user_options = v;
      }
    },
    teamOptions:{
      get(){
        return this.team_options;
      },
      set(v){
        this.team_options = v;
      }
    },
    showModal() {
      return this.show_modal;
    }
  },
  methods: {
    showModalWindow(data) {
      this.show_modal = true;
      this.titleStyle = data.title_style || "";

      this.$ajax.post("/master_user/load_for_bulk_import/", {}, (err, data) => {
        this.localUserList = data;
      });
    },
    closed(mode) {
      if(typeof mode != "undefined"){
        console.log("mode",mode)
        this.show_modal = false;
        this.$emit('done',mode);
      }
    }
  },
  props: {
    tag: { type: String, default: "showAppConfimationModal" }
  },
  mounted() {
    bus.$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy() {
    bus.$off(this.$props.tag);
  }
};
</script>
<style scoped>
th{
  background: #aba7a7;
  color: white;
  padding:2px 3px;
}
tr{
  height: 25px;
}
td{
  padding:4px 3px;
}
</style>



// WEBPACK FOOTER //
// device-embedded-information-application-confirmation-modal.vue?22a62641